export const destinationsList = [
  { name: 'ain-sokhna', label: 'Ain Sokhna', lat: 29.6002, lng: 32.3167 },
  { name: 'north-coast', label: 'North Coast', lat: 31.0, lng: 28.0 },
  { name: 'west-cairo', label: 'West Cairo', lat: 30.0444, lng: 31.2357 },
  { name: 'east-cairo', label: 'East Cairo', lat: 30.0444, lng: 31.4357 },
  { name: 'el-gouna', label: 'El Gouna', lat: 27.02, lng: 33.81 },
  {
    name: 'downtown-cairo',
    label: 'Downtown Cairo',
    lat: 30.044402707545906,
    lng: 31.235758232127115,
  },
];
